module.exports = __webpack_public_path__ + "img/Art04-19710261-2042.ba50207b.jpg";